/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const PENDING_PURCHASE_COLUMNS = [
  { id: "created_at", label: "Date", accessorKey: "created_at", filterType: "date" },
  { id: "vehicle_number", label: "Vehicle", accessorKey: "vehicle_number", filterType: "text" },
  { id: "code", label: "Code", accessorKey: "code", filterType: "text" },
  { id: "party_name", label: "Party", accessorKey: "party_name", filterType: "text" },
  { id: "variety", label: "Variety", accessorKey: "variety", filterType: "text" },
  { id: "gate_pass_code", label: "Gate pass", accessorKey: "gate_pass_code", filterType: "text" },
  { id: "pravesh_parchi_no", label: "Pravesh parchi", accessorKey: "pravesh_parchi_no", filterType: "text", hideInTable: true },
];

/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const VOUCHER_COLUMNS = [
  { id: "code", label: "Voucher", accessorKey: "code", filterType: "text" },
  {
    id: "voucher_type",
    label: "Type",
    accessorKey: "voucher_type",
    filterType: "select",
    filterOptions: [
      { value: "", label: "All" },
      { value: "MATERIAL", label: "Material" },
      { value: "FREIGHT", label: "Freight" },
      { value: "CASH", label: "Cash" },
    ],
  },
  { id: "purchase_code", label: "Purchase", accessorKey: "purchase_code", filterType: "text" },
  { id: "party_name", label: "Party", accessorKey: "party_name", filterType: "text" },
  { id: "variety", label: "Variety", accessorKey: "variety", filterType: "text" },
];

/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const CASH_LEDGER_COLUMNS = [
  { id: "code", label: "Voucher", accessorKey: "code", filterType: "text" },
  {
    id: "entry_type",
    label: "Type",
    accessorKey: "entry_type",
    filterType: "select",
    filterOptions: [
      { value: "", label: "All" },
      { value: "PAYMENT", label: "Payment" },
      { value: "RECEIPT", label: "Receipt" },
    ],
  },
  { id: "party_name", label: "Party", accessorKey: "party_name", filterType: "text" },
  { id: "purchase_code", label: "Purchase", accessorKey: "purchase_code", filterType: "text" },
];

/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const CASH_PAYMENT_COLUMNS = [
  { id: "code", label: "Cash voucher", accessorKey: "code", filterType: "text" },
  { id: "purchase_code", label: "Purchase", accessorKey: "purchase_code", filterType: "text" },
  { id: "party_name", label: "Party", accessorKey: "party_name", filterType: "text" },
];
